/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_blog_table_of_contents = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Table of Contents`)
};

const es_blog_table_of_contents = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tabla de contenidos`)
};

const de_blog_table_of_contents = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inhaltsverzeichnis`)
};

const nl_blog_table_of_contents = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inhoudsopgave`)
};

const fr_blog_table_of_contents = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Table des matières`)
};

const it_blog_table_of_contents = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indice`)
};

const pt_br2_blog_table_of_contents = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Índice`)
};

const pt_blog_table_of_contents = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Índice`)
};

const ja_blog_table_of_contents = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目次`)
};

const zh_blog_table_of_contents = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目录`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const blog_table_of_contents = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.blog_table_of_contents(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("blog_table_of_contents", locale)
	if (locale === "en") return en_blog_table_of_contents(inputs)
	if (locale === "es") return es_blog_table_of_contents(inputs)
	if (locale === "de") return de_blog_table_of_contents(inputs)
	if (locale === "nl") return nl_blog_table_of_contents(inputs)
	if (locale === "fr") return fr_blog_table_of_contents(inputs)
	if (locale === "it") return it_blog_table_of_contents(inputs)
	if (locale === "pt-BR") return pt_br2_blog_table_of_contents(inputs)
	if (locale === "pt") return pt_blog_table_of_contents(inputs)
	if (locale === "ja") return ja_blog_table_of_contents(inputs)
	return zh_blog_table_of_contents(inputs)
};